import React,{useState ,Fragment ,useReducer, useContext, useEffect, useRef} from "react";
import { Link ,useHistory, useLocation} from "react-router-dom";
import nav_data from './NavData';
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Image
import profile_h from "../../../images/user.jpg";
import avatar from "../../../images/logo.png";
import LogoutPage from './Logout';
import Slider from "react-slick";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { ThemeContext } from "../../../context/ThemeContext";
import { GlobalSet } from '../../components/global/GlobalProvider';
import { Row, Card, Col, Button, Modal, Container, Dropdown ,Badge } from "react-bootstrap";
import swal from "sweetalert";
import axios from "axios";


import "./Rav.css"; // Custom CSS for additional styling
import subimg1 from "../../../images/frontend/exchange_bdt_03.png";
import subimg2 from "../../../images/frontend/exchange_bdt_02.png";
import apps_h from "../../../images/svg/apps.svg";
import help_h from "../../../images/svg/help.svg";

import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';

const Header = ({ onNote }) => {
  const var_casino= nav_data.casino;
  const var_sports= nav_data.sports;
  const { CurrencySymbol } = GlobalSet();
  const { BaseUrl } = GlobalSet();
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const auth_token = localStorage.getItem('auth_token');
  // Check if ?login is in the URL, and open the modal
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("login")) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [location]);

  const { navigationHader, openMenuToggle, background } = useContext(
    ThemeContext
  );
  // Close the modal and remove ?login from the URL
  const handleClose = () => {
    setShow(false);
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("login");
    history.replace({
      search: searchParams.toString(),
    });
  };



  var casino_home = BaseUrl + "public/appssource/sports_icons/casino-home.png";
  var sports_home = BaseUrl + "public/appssource/sports_icons/sports-home.png";
  var political_bet = BaseUrl + "public/appssource/sports_icons/political-bet.png";
  var plan_crash = BaseUrl + "public/appssource/sports_icons/plan-crash.png";
  var home_nav = BaseUrl + "public/appssource/sports_icons/home_nav.png";
  var Exclusive = BaseUrl + 'public/appssource/sports_icons/Exclusive.png';
  var Sports_nav = BaseUrl + "public/appssource/sports_icons/Sports.png";
  var Live_nav = BaseUrl + "public/appssource/sports_icons/Live.png";
  var Slots_nav = BaseUrl + "public/appssource/sports_icons/slots.png";
  var Type_nav = BaseUrl + "public/appssource/sports_icons/Type.png";
  var Live_nav = BaseUrl + "public/appssource/sports_icons/Live.png";
  var Table_nav = BaseUrl + "public/appssource/sports_icons/Table.png";
  var Fishing_nav = BaseUrl + "public/appssource/sports_icons/fishing.png";
  var lottery_h_nav = BaseUrl + "public/appssource/sports_icons/lottery_h.png";




  // Image sources
  const banner_sports = BaseUrl + "public/appssource/provider_icon/deccan-gladiators.png";
  const banner_virtualsports = BaseUrl + "public/appssource/provider_icon/sunrisers-eastern-cape.png";
  const banner_skyexchangeBlog = BaseUrl + "public/appssource/provider_icon/bologna-fc-1909.png";
  const banner_kabaddi = BaseUrl + "public/appssource/provider_icon/quetta-gladiators.png";

  const row1Images = [banner_sports, banner_virtualsports, banner_skyexchangeBlog];
  const row2Images = [banner_kabaddi, banner_skyexchangeBlog, banner_virtualsports];

  // State to manage indices of images for two rows
  const [row1Index, setRow1Index] = useState(0);
  const [row2Index, setRow2Index] = useState(0);

  // Auto change images every 2 seconds
  useEffect(() => {
    const interval1 = setInterval(() => {
      setRow1Index((prev) => (prev + 1) % row1Images.length);
    }, 2000);

    const interval2 = setInterval(() => {
      setRow2Index((prev) => (prev + 1) % row2Images.length);
    }, 2000);

    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
    };
  }, [row1Images.length, row2Images.length]);





//mobile odds option
  const casino_game_s = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 100,
    slidesToShow: 10,
    slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1560,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 6,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 5,
                },
            },  
            {
                breakpoint: 640,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 4,
                },
            },
        ],
  };

  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const images = [
    { src: subimg1, alt: "Sport 1" },
    { src: subimg2, alt: "Sport 2" },
    { src: subimg1, alt: "Sport 3" },
    { src: subimg2, alt: "Sport 4" },
    { src: subimg1, alt: "Sport 5" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
 
  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 2 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 2 : prevIndex - 1
    );
  };

  const visibleImages = images.slice(currentIndex, currentIndex + 3).concat(
    currentIndex + 3 > images.length
      ? images.slice(0, currentIndex + 3 - images.length)
      : []
  );


  // Open the modal by adding ?login to the URL
  const handleShowLogin = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("login", "true");
    history.replace({
      search: searchParams.toString(),
    });
  };

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(timer);
  }, []);

    const [loginInput, setLogin] = useState({
        username: '',
        password: '',
        error_list: [],
    });

    const handleInput = (e) => {
        e.persist();
        setLogin({...loginInput, [e.target.name]: e.target.value });
    }

    const loginSubmit = (e) => {
        e.preventDefault();
        
        const data = {
            username: loginInput.username,
            password: loginInput.password,
            key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
        }
            axios.post(`/apps-user-login`, data).then(res => {
                if(res.data.status === 'success')
                {
                    localStorage.setItem('auth_token', res.data.accessToken);
                    //swal("Success",res.data.message,"success");
                    //history.push('/');
                    swal("Success",res.data.message,"success");
                  window.location.href = '/'; 
 
                }
                else if(res.data.status === 'fail')
                {

                    swal("Warning",res.data.message,"warning");
                }
                else 
                {
                setLogin({...loginInput, error_list: res.data.validation_error});
                }
            });
          }


  const [showModal, setShowModal] = useState(false); // For modal visibility
  const toggleModal = () => {
    setShowModal(!showModal); // Toggle modal visibility
  };

  const handleLanClick = (divLang) => {
    localStorage.setItem('selectedLanguage', divLang);
    window.location.reload();
  };

  let  divLang;
  const sel_Language = localStorage.getItem('selectedLanguage');
  if (sel_Language !== null) {
   divLang = sel_Language;
  } else {
   divLang = "en";
  }
  const [selectedLanguage, setSelectedLanguage] = useState(divLang);
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setSelectedLanguage(language);
  };


  const handleCarClick = (divCarr) => {
    localStorage.setItem('selectedCurrency', divCarr);
      let  cur_icon;
    if (divCarr === "USD") {
     cur_icon = "$";
    } else if (divCarr === "EUR"){
     cur_icon = "€";
    } else if (divCarr === "BDT"){
     cur_icon = "৳";
    } else if (divCarr === "INR"){
     cur_icon = "₹";
    }
    localStorage.setItem('CurrencySymbol', cur_icon);
    window.location.reload();
  };
  let  divCarr;
  const sel_cudrrency = localStorage.getItem('selectedCurrency');
  if (sel_cudrrency !== null) {
   divCarr = sel_cudrrency;
  } else {
   divCarr = "USD";
  }
  const [selectedCurrency, setSelectedCurrency] = useState(divCarr);
  
  const [settingToggle, setSettingToggle] = useState(false);
  const [demoToggle, setDemoToggle] = useState(false);

   const [user, setUser] = useState(null);
   const [balance, setBalance] = useState(0); // Separate balance state
   const fetchProfileData = () => {
      const data = {
        key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
        currency: selectedCurrency,
      };
      if (auth_token !== null) {
        axios.post('/apps-profile', data)
          .then(response => {
            setUser(response.data);
            setBalance(response.data?.data?.balance || 0); // Update balance
          })
          .catch(error => {
            console.log(error);
          });
      }
    };
    useEffect(() => {
      fetchProfileData();
      const intervalId = setInterval(fetchProfileData, 5000);
      return () => clearInterval(intervalId);
    }, []);


var AuthButtons = '';
if(!localStorage.getItem('auth_token'))
{
  AuthButtons = (
  <ul className="navbar-nav header-right">

      <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
              <Modal.Title>Login Here</Modal.Title>
          </Modal.Header>
           <Modal.Body>
              <form onSubmit={loginSubmit}>
                <div className="form-group mb-3">
                   <div className="form-group">
                      <div className="form-group mb-3">
                           <label className="mb-1">
                              <strong className="text-black">Username</strong>
                            </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="username"
                           name="username"
                         onChange={handleInput} 
                         value={loginInput.username}
                          />
                       </div>
                      <span>{loginInput.error_list.username}</span>
                     

                        <label className="text-label text-black">Password</label>
                        <div className="input-group transparent-append mb-2">
                          
                            <span className="input-group-text">
                              {" "}
                              <i className="fa fa-lock" />{" "}
                            </span>
                          
                          <input
                            type={`${showPassword ? "text" : "password"}`}
                            className="form-control"
                            id="val-password1"
                            placeholder="password"
                            name="password"
                            onChange={handleInput} 
                            value={loginInput.password}
                          />

                          <div
                            className="input-group-text "
                            onClick={() => setShowPassword(!showPassword)}
                          >

                              {" "}
                  {showPassword === false ? (<i className="fa fa-eye-slash" />) : (<i className="fa fa-eye" />)}
                            
                          </div>
                          <div
                            id="val-username1-error"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                          >
                          </div>


                        </div>
                     <span>{loginInput.error_list.password}</span>
                      <div className="text-center mt-4">
                          <button type="submit" className="btn btn-primary btn-block">
                            Login
                          </button>
                      </div>
                  </div>
                </div>
            </form>
            <div className="new-account mt-3">
          <p><span className="text-black">New account? <Link className="text-black" to="./register">Sign up</Link></span>
          <span style={{ float: 'right' }}><Link className="text-black" to="./forgot-password">Forgot Password ?</Link></span>
          </p>
        </div>
          </Modal.Body>
      </Modal>


    <div className="d-flex align-items-center justify-content-center p-3 text-white" style={{ textAlign: 'center' }}>
      <button className="btn btn-secondary mr-5 d-none d-lg-block d-xl-block">
      <Link className="text-white" to="?login=true" >
        Login 
      </Link>
      </button>
      

      <Link className="d-none d-lg-block d-xl-block" to="/register" >
      <button className="btn btn-danger">
        signup <i className="bi bi-box-arrow-in-right"></i>
      </button>
      </Link>

      <Link style={{  paddingRight: '10px' }} className="d-block d-sm-none" to="/" >
        <img src={apps_h} width={25} alt="Profile" /> 
        <span className="text-white">Apps</span>         
      </Link>

      <Link style={{  paddingLeft: '10px' }}  className="d-block d-sm-none" to="/support-center" >
        <img src={help_h} width={30} alt="Profile" />
        <span className="text-white">Support</span>    
      </Link>





    </div>


  </ul>
   );
    }
    else
    {
  AuthButtons = (
  <ul className="navbar-nav header-right">
  


    <Dropdown as="li" className="nav-item dropdown header-profile" style={{ marginRight: '0px'}}>
        <button type="button"  onClick={toggleModal} className="me-2 btn btn-dark btn-rounded d-none d-sm-block">
          <span className="fa fa-globe text-white" onClick={fetchProfileData} >
          {' ' + divLang.toUpperCase() + ' , '}
          </span>
          {' ' + divCarr }
        </button>


            <ul className="navbar-nav header-right d-none d-sm-block">
                <div as="li" className="nav-item">     
                 <Link to="/deposit">
                    <button type="button" class="me-2 btn btn-warning">Deposit</button>
                   </Link>
                </div>
            </ul>


        <button type="button" className="me-2 btn btn-dark btn-rounded with-nav-p">
            <span className="d-none d-sm-block btn-icon-start text-primary" onClick={fetchProfileData} >
            <i className="ti-reload"></i>
            </span> 

          <Link style={{ fontsize: '10px' }} to="/deposit" >
          <span className="d-block d-sm-none">
              <span className="btn-icon-start text-primary" >Deposit</span>       
          </span>
          </Link>  

          {CurrencySymbol}{parseFloat(parseFloat(balance).toFixed(2))} 
        </button>

      <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
       <Link to={"/menu"}>
        <img src={profile_h} width={30} alt="Profile" />
        </Link>
      </Dropdown.Toggle>
    </Dropdown>
  </ul>
        );
    }

const [searchBut, setSearchBut] = useState(false);  
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName.includes("app")
    ? filterName.filter((f) => f !== "app")
    : filterName.includes("ui")
    ? filterName.filter((f) => f !== "ui")
    : filterName.includes("uc")
    ? filterName.filter((f) => f !== "uc")
    : filterName.includes("basic")
    ? filterName.filter((f) => f !== "basic")
    : filterName.includes("jquery")
    ? filterName.filter((f) => f !== "jquery")
    : filterName.includes("table")
    ? filterName.filter((f) => f !== "table")
    : filterName.includes("page")
    ? filterName.filter((f) => f !== "page")
    : filterName.includes("email")
    ? filterName.filter((f) => f !== "email")
    : filterName.includes("ecom")
    ? filterName.filter((f) => f !== "ecom")
    : filterName.includes("chart")
    ? filterName.filter((f) => f !== "chart")
    : filterName.includes("editor")
    ? filterName.filter((f) => f !== "editor")
    : filterName;
  return ( 
     <>

     <nav
        className="navbar navbar-expand-lg navbar-first"
        style={{
          backgroundColor: '#2d2d2d',
          paddingTop: '0px',
          paddingBottom: '0px',
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 1000,
        }}
      >
        <div className="container-fluid d-none d-lg-block d-xl-block">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <span className="nav-link" style={{ color: 'white', fontSize: '13px' }}>
                  Time Zone: GMT {currentTime.toLocaleTimeString()}
                </span>
              </li>
              <li className="nav-item">
                <button type="button" onClick={toggleModal} className="nav-link text-black" style={{ background: '#555555' }}>
                  <span className="fa fa-globe text-white" onClick={fetchProfileData}>
                    {' ' + divLang.toUpperCase() + ' , '}
                  </span>
                  {' ' + divCarr}
                </button>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/sportsbook" style={{ color: 'white' }}>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/sportsbook" style={{ color: 'white' }}>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/sportsbook" style={{ color: 'white' }}>
                </Link>
              </li>
            </ul>
            <div className="ms-auto me-2 text-white" style={{ color: 'white' }}>
              Time Zone: GMT+5:30
            </div>
            <span
              className="ms-2 text-white"
              style={{
                cursor: 'pointer',
                borderLeft: '2px solid #ddd', // Left border color
                paddingLeft: '8px', // Space between text and border
              }}
            >
              <i className="fab fa-whatsapp" style={{ marginLeft: '4px' }} /> Whatsapp
            </span>
            <span
              className="ms-2 text-white"
              style={{
                cursor: 'pointer',
                borderLeft: '2px solid #ddd', // Left border color
                paddingLeft: '8px',
              }}
            >
              <i className="fa fa-envelope" /> Email
            </span>
            <span
              className="ms-2 text-white"
              style={{
                cursor: 'pointer',
                borderLeft: '2px solid #ddd', // Left border color
                paddingLeft: '8px',
              }}
            >
              <i className="fab fa-facebook-f" /> Facebook
            </span>
            <span
              className="ms-2 text-white"
              style={{
                cursor: 'pointer',
                borderLeft: '2px solid #ddd', // Left border color
                paddingLeft: '8px',
              }}
            >
              <i className="far fa-comments" /> Forum
            </span>
          </div>

        </div>
      </nav>

      {/* Second Header */}
        <div style={{ zIndex: 998, paddingLeft: '0px', background: '#3d3d3d', fontSize: '14px', height: '70px' }} className="header border-bottom margin-top-three">
        <div style={{ paddingLeft: '6px' }} className="header-content des-nav-ziro">

        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">


             <div className="d-block d-sm-none">
              {/* Overlay */}
              {isOpen && <div className="overlay" onClick={() => setIsOpen(false)}></div>}

              {/* Toggle Button */}

              <button className="btn btn-warning toggle-btn" onClick={toggleMenu}>
                <i className={isOpen ? 'fa fa-times' : 'fa fa-bars'} aria-hidden="true"></i>
              </button>


              {/* Sidebar */}
              <div
                ref={sidebarRef}
                className={`sidebar ${isOpen ? 'open' : ''}`}
              >
                <div className="sidebar-header">
                  <img
                    src={avatar}
                    alt="Sky247 Logo"
                    className="sidebar-logo"
                  />
                </div>
                <ul className="sidebar-menu" style={{ display: 'block' }}>
                  <li>
                    <Link to='/'>
                      <img src={home_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Home
                     </Link>
                  </li>
                  <hr/>
                  <li>
                    <Link to='/sportsbook'>
                      <img src={Sports_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Sports
                     </Link>
                  </li>
                  <hr/>
                  <li>
                    <a href="/home-game/live-casino">
                      <img src={Live_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Live Casino
                    </a>
                  </li>
                  <hr/>
                  <li>
                    <a href="/home-game/slots">
                      <img src={Slots_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Slots
                    </a>
                  </li>
                  <hr/>
                  <li>
                    <a href="/home-game/table-game">
                      <img src={Type_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Table
                    </a>
                  </li>
                  <hr/>
                  <li>
                    <a href="/home-game/fishing">
                      <img src={Fishing_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Fishing
                    </a>
                  </li>
                  <hr/>
                  <li>
                    <a href="/home-game/lottery">
                      <img src={Table_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Lottery
                    </a>
                  </li>
                  <hr/>
                  <li>
                    <a href="/bonus">
                      <img src={lottery_h_nav} style={{ width: '40px', height : '40px' }} alt="Home" className="menu-icon" />
                      Bonus
                    </a>
                  </li>
                </ul>
              </div>
            </div>



            <Link to="/" className="brand-logo" style={{ marginLeft : '65px'}}>
              {background.value === "dark" || navigationHader !== "color_1" ? (
            <Fragment>
            <img style={{ width:"100%", marginLeft: '10px' }} className="form-inline " src={avatar} alt=""/>
            </Fragment>
              ) : (
            <Fragment>
            <img style={{ width:"100%",marginLeft: '10px' }} className="form-inline " src={avatar} alt=""/>
            </Fragment>
              )}
            </Link>


                <div className="row ml-2" style={{ marginLeft: '20px' }} >
                    <div className="col-xl-6 col-xxl-2 col-lg-2 col-md-2 col-sm-2 col-2 int-col p-1"> 
                          <div>
                            <img src={row1Images[row1Index]} alt="Row 1" className="image img-fluid" />
                          </div>  
                      </div> 

                    <div className="col-xl-6 col-xxl-2 col-lg-2 col-md-2 col-sm-2 col-2 int-col p-1">                        
                          <div>
                            <img src={row2Images[row2Index]} alt="Row 2" className="image img-fluid" />
                          </div>  
                      </div> 
                </div>


             <ul className="navbar-nav header-right">
               {AuthButtons}
              </ul>
         </div>
        </nav>
        </div>
    </div>

      {/* Third Navbar */}
      <nav
        className="navbar navbar-expand-lg navbar-third"
        style={{
          backgroundColor: '#2d2d2d',
          position: 'fixed',
          top: '100px',
          width: '100%',
          zIndex: 998,
          padding: '0px',
        }}
      >
        <div className="container-fluid">
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto" style={{ display: 'flex', alignItems: 'center' }}>
              <li className="nav-item" style={{ display: 'flex', alignItems: 'center' }}>
                <a className="nav-link" href="#" style={{ fontSize: '20px' }}>
                  <i className="fa fa-home"></i>
                </a>
              </li>
              <li className="nav-item" style={{ display: 'flex', alignItems: 'center', borderLeft: '1px solid #ddd' }}>
                <a className="nav-link" href="#" style={{ margin: '0 15px', fontSize: '20px' }}>
                  <i className="fa fa-mobile"></i>
                </a>
              </li>

              <li className="nav-item dropdown" style={{ display: 'flex', alignItems: 'center', borderLeft: '1px solid #ddd' }}>
                <a className="nav-link dropdown-toggle" href="#" style={{ margin: '0 15px' }} id="sportsDropdown" role="button">
                  <span>Sports</span>
                </a>
              <div style={{ marginLeft: '450% '}} className="dropdown-menu full-width-dropdown centered-element">
                <div className="col-12 mt-3">
                  <div className="card mb-2">
                    <div className="pt-1 pb-1">
                      <Slider
                        className="front-view-slider owl-carousel owl-carousel owl-loaded owl-drag owl-dot"
                        {...casino_game_s}
                      >
                        {var_sports.map((product)=>(
                                <div className="p-1">
                                  <div key={product.id}>
                                    <Link to={product.slug} className="text-black user-name">
                                      <h4 className="text-center">  {t(product.name)} </h4>
                                      <div className="img-bx">
                                        <img
                                          src={BaseUrl + 'public/' + product.photo}
                                          alt=""
                                          className="me-3 card-list-img"
                                          width="100"
                                        />
                                      </div>
                                      <h4 className="text-center"> Play Now </h4>
                                    </Link>
                                  </div>
                                </div>
                          ))}


                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
              </li>
            {var_casino.map((product)=>(
              <li className="nav-item" style={{ display: 'flex', alignItems: 'center', borderLeft: '1px solid #ddd' }}>
               <Link to={product.slug} className="nav-link" style={{ margin: '0 15px' }}>{t(product.name)}</Link>
              </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>


        {showModal && (
            <div className="modal show" tabIndex="-1" role="dialog" style={{ display: "block" }}>
              <div className="modal-dialog" role="document">
                <div style={{marginTop: '100px', background: '#3e3e3e'}} className="modal-content">
                  <div className="modal-header" style={{ background: '#121212' }}>
                    <h5 className="modal-title">Select Country</h5>
                    <button
                      type="button"
                      onClick={toggleModal}
                      aria-label="Close"
                    >
                      <span style={{ padding: '5px', fontSize: '10px' }} aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">

                      <div className="row">

                     <div class="col col-lg-6">
                      <div className="mail-list rounded  mt-4">

                        <Link onClick={() => handleLanClick('en')} className={"list-group-item text-black " + (divLang === 'en'  && "active" )} >
                        <i className="fa fa-language font-18 align-middle me-2 text-black"></i>
                        English
                        </Link>
                        <Link onClick={() => handleLanClick('fr')} className={"list-group-item text-black " + (divLang === 'fr'  && "active" )}>
                        <i className="fa fa-language font-18 align-middle me-2 text-black"></i>
                        Français
                        </Link>
                        <Link onClick={() => handleLanClick('bn')} className={"list-group-item text-black " + (divLang === 'bn'  && "active" )}>
                        <i className="fa fa-language font-18 align-middle me-2 text-black"></i>
                        বাংলা
                        </Link>
                        <Link onClick={() => handleLanClick('hi')} className={"list-group-item text-black " + (divLang === 'hi'  && "active" )}>
                        <i className="fa fa-language font-18 align-middle me-2 text-black"></i>
                        हिंदी
                        </Link>
                      </div>
                      </div>

                     <div class="col col-lg-6 text-black">
                          <div className="mail-list rounded text-black mt-4">

                            <Link onClick={() => handleCarClick('USD')} className={"list-group-item text-black " + (divCarr === 'USD'  && "active" )} >
                            <i className="fa fa-globe font-18 align-middle me-2 text-black"></i>
                            USD
                            </Link>
                            <Link onClick={() => handleCarClick('EUR')} className={"list-group-item text-black " + (divCarr === 'EUR'  && "active" )}>
                            <i className="fa fa-globe font-18 align-middle me-2 text-black"></i>
                            EUR
                            </Link>
                            <Link onClick={() => handleCarClick('BDT')} className={"list-group-item text-black " + (divCarr === 'BDT'  && "active" )}>
                            <i className="fa fa-globe font-18 align-middle me-2 text-black"></i>
                            BDT
                            </Link>
                            <Link onClick={() => handleCarClick('INR')} className={"list-group-item text-black " + (divCarr === 'INR'  && "active" )}>
                            <i className="fa fa-globe font-18 align-middle me-2 text-black"></i>
                            INR
                            </Link>
                        </div>
                      </div>
                   </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={toggleModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}


     </>

  );
};

export default Header;
